import { MYACCOUNTPAGE } from "arv-extends/constants";

MYACCOUNTPAGE.MYACCOUNT.SHOW_SUBTITLES = true;
MYACCOUNTPAGE.FAVORITES.PRODUCT_ADDED = "We've added this product to your cart";
MYACCOUNTPAGE.FAVORITES.CTAS.MOVE_TO_BAG = "Move to Cart";
export default MYACCOUNTPAGE;
